module.exports = __webpack_public_path__ + "img/core.ce7de315.svg";